'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { useSignUpGuestStore } from '@/features/sign-up'

import { SignUpGuestInfo } from './info'
import { SignUpGuestIntro } from './intro'
import { SignUpGuestTerms } from './terms'
import { SignUpGuestVerification } from './verification'
import { useValidateGuestStep } from '../lib/use-validate-guest-step'

export const SignUpGuestPage = () => {
  useValidateGuestStep()

  const searchParams = useSearchParams()

  const actions = useSignUpGuestStore(state => state.actions)

  const step = searchParams?.get('step') || 'intro'

  useEffect(() => {
    return () => {
      actions.reset()
    }
  }, [actions])

  return (
    <>
      {(() => {
        if (step === 'intro') {
          return <SignUpGuestIntro />
        }

        if (step === 'terms') return <SignUpGuestTerms />

        if (step === 'info') return <SignUpGuestInfo />

        if (step === 'verification') return <SignUpGuestVerification />

        return <SignUpGuestIntro />
      })()}
    </>
  )
}
